import 'airbnb-js-shims';
import React from 'react';
import Slider from 'react-slick';

import Hand from '../../styled-components/Hand';
import LightWindowWrapper from '../../styled-components/LightWindowWrapper';
import LightWindowBox from '../../styled-components/LightWindowBox';
import CloseWindow from '../../styled-components/CloseWindow';

import lazer from '../../img/lazer.jpg';
import gestured from '../../img/gestured.svg';
import gestured2 from '../../img/gestured-2.svg';
import thumbsUp from '../../img/thumbs-up.svg';
import thumbsUp2 from '../../img/thumbs-up2.svg';
import pointer from '../../img/pointer-2.svg';
import invertedCurved from '../../img/inverted-curved.svg';
import spalyed from '../../img/spalyed.svg';

import close from '../../img/close.svg';
import arrow from '../../img/arrow.svg';

function SampleNextArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{display: 'block'}}
      onClick={onClick}
    >
      <img src={arrow} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{display: 'block'}}
      onClick={onClick}
    >
      <img src={arrow} />
    </div>
  );
}

class LightWindow extends React.Component {
  constructor() {
    super()
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    document.addEventListener('keydown', this.handleClick);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleClick);
  }
  handleClick(e) {
    if(e.key === 'ArrowRight') this.slider.slickNext();

    if(e.key === 'ArrowLeft') this.slider.slickNext();

    if(e.key === 'Escape') this.props.hideModal();
  }
  componentDidUpdate() {
    this.slider ? this.slider.slickGoTo(this.props.slideIndex) : null
  }
  render() {
    const hands = [ gestured, gestured2, thumbsUp, pointer, invertedCurved, spalyed ];
    const hideModal = e => {
      e.stopPropagation();
      this.props.hideModal;
    }
    const settings = {
      adaptiveHeight: true,
      slidesToShow: 1,
      speed: 0,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    if(this.props.showModal == false) {
      return null
    }
    return (
      <LightWindowWrapper onClick={e => hideModal(e)} showModal={this.props.showModal}>
        <Hand src={hands[this.props.hand]} top="100px" left="-2%" hideOnMobile />
        <Hand src={hands[this.props.hand]} top="5%" left="0" onlyOnMobile style={{height: '10%', width: 'auto'}} />
        <LightWindowBox>
          <CloseWindow onClick={this.props.hideModal}><img src={close} /></CloseWindow>
          <Slider ref={slider => this.slider = slider} {...settings}>
            {this.props.children}
          </Slider>
        </LightWindowBox>
      </LightWindowWrapper>
    )
  }
}

export default LightWindow;



// WEBPACK FOOTER //
// ./src/components/LightWindow/index.js